module.exports = __webpack_public_path__ + "img/part-3-1.1a7f25a2.webp";